// extracted by mini-css-extract-plugin
export default {"wrapper":"J2-z","play":"K2-z"};